/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Italics_TooltipInputs */

const en_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for Events where all lines are italicized`)
};

const fr_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifier les evenements ou toutes les lignes sont en italique`)
};

const de_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie auf Ereignisse, bei denen alle Zeilen kursiv sind.`)
};

const it_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla gli eventi in cui tutte le righe sono in corsivo`)
};

const ru_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте события, в которых все строки выделены курсивом.`)
};

const es_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobar eventos donde todas las líneas están en cursiva`)
};

const zh_cn2_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查所有行都为斜体的事件`)
};

const ja_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての行が斜体になっているイベントをチェックする`)
};

const hi_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन घटनाओं की जाँच करें जहाँ सभी पंक्तियाँ इटैलिक में लिखी गई हैं।`)
};

const pt_pt2_style_guide_manager_italics_tooltip = /** @type {(inputs: Style_Guide_Manager_Italics_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique os eventos em que todas as linhas estão em itálico.`)
};

/**
* | output |
* | --- |
* | "Check for Events where all lines are italicized" |
*
* @param {Style_Guide_Manager_Italics_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_italics_tooltip = /** @type {((inputs?: Style_Guide_Manager_Italics_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Italics_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_italics_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_italics_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_italics_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_italics_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_italics_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_italics_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_italics_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_italics_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_italics_tooltip(inputs)
	return en_style_guide_manager_italics_tooltip(inputs)
});